import { components } from "react-select";

const CustomValueContainer = (props: any) => {
    //const value = props.getValue();
    let children = [...props.children];

    /*if (value.length > 0) {
        const newItems = [];
        let i = 0;
        for (let item of children[0]) {
            if (i > 3) {
                newItems.push('...');
                break;
            }
            if (i > 0) {
                newItems.push(', ');
            }
            newItems.push(item);
            i++;
        }
        children[0] = newItems;
    }*/

    return <components.ValueContainer {...props}>{children}</components.ValueContainer>
};

export default CustomValueContainer;